<template lang="pug">
  div.upper-subpanel--inside(style="display: block; padding: 0.5rem 1rem")
    ScanBarcode(v-show="false" v-on:setBarcode="getBarcode")
    div(style="display: block; margin: 10px 0")
      span(style="margin-right: 20px; white-space: nowrap; display: inline-block") 1. 請輸入病歷號(或直接掃描 QR Code帶入先前排程): 
      div(v-if="manualInputMedRecordId == true")
        input.form-control-sm.form-control(v-model="medRecordId" style="width: 200px; display: inline-block" ref="medInput")  
      div(v-if="manualInputMedRecordId == false")
        input.form-control-sm.form-control(v-model="medRecordId" style="width: 200px; display: inline-block" ref="medInput" disabled)
    div
      //- span 2.請選擇套藥
      p 2. 選擇類別: 
        span(v-if="selectedSet" style="color: red") {{selectedSet}}
      div.button-wrapper(v-if="selectedSet === undefined")
        div.control-button-custom.control-button.control-button-green.m-1(
          v-for="set, set_ind in combos" 
          style="width: 120px"
          @click="selectedSet = set.dep_name")
          div.button-inside-wrap {{ set.dep_name }}
      p 3. 選擇套藥
      div.button-wrapper(v-if="selectedSet !== undefined")
        div.control-button-custom.control-button.control-button-green.m-1(
          v-for="combo, combo_ind in combosets[selectedSet].combolist" 
          @click="setCombo(combo, combo_ind)" 
          :class="{ 'control-button-selected': combo.selected }")
          div.button-inside-wrap {{ combo.generic_name }}
        //- span {{ combosets[selectedSet] }}
        //- hr(style="margin: 0.5rem 0")
    div(style="position: absolute; right: 500px;bottom: -97px;")
      button(class="btn control-button control-button-red" @click="gotoFetchDrugGroup") 類別取藥
    div(style="position: absolute; right: 10px;bottom: -97px;")
      button(class="btn control-button control-button-red" @click="startAction") 下一步驟
    //- div.col-12(v-if="currentProgress === 'selectBed'")
    //-   div.with-child-centered(style="width: 100%")
    //-     h4.text-center.mt-2 請選擇床號
    //-     div.button-wrapper
    //-       div.btn.control-button.control-button-green.m-1(v-for="bed, ind in beds" @click="setBed(bed, ind)" :class="{ 'control-button-selected': bed.selected }") 
    //-         div.button-inside-wrap
    //-           span {{ bed.code }}
    //-   br
    //- div.col-12(v-if="currentProgress === 'selectMed'")
    //-   h4.text-center 
    //-     span(v-if="selectMedType === 'set'") 選擇套藥
    //-     span(v-if="selectMedType === 'group'") 群組選藥
    //-   button.btn.btn-sm.btn-success(@click="changeSelectMedType" style="position: absolute; top: 0; right: 15px;")
    //-     span 切換為
    //-     span(v-if="selectMedType === 'set'") 群組
    //-     span(v-if="selectMedType === 'group'") 套藥
    //-   hr(style="margin: 0.5rem")
    //-   div.row 
    //-     div.col-12(v-show="selectMedType === 'set'")
    //-       div.med-group-wrapper
    //-         ul.nav.nav-pills.nav-fill.nav-autoix
    //-           li.nav-item(v-for="g, index in comboSet" @click="currentComboSetIndex = index")
    //-             div.nav-link(:class="{ 'active': currentComboSetIndex === index }" ) {{g.name}}
    //-         div.med-select(style="height: 360px; overflow-y: auto")
    //-           div.med-button(
    //-             :class="{ 'selected-med-button': med.selected, 'unselectable': med.amountInSystem === 0 }"
    //-             v-for="med, index in comboSet[currentComboSetIndex].childMedSet"
    //-             @click="selectMed('comboSet', index)") 
    //-             div#med_desc
    //-               h6 {{ med.code }} - {{ med.CGMH_number }}
    //-               h6 {{ med.generic_name }}
    //-             div#remain_amount 
    //-               span 系統存量
    //-               span {{ med.amountInSystem }}

    //-       //- div.med-group-wrapper
    //-       //-   div.med-select(style="height: 400px; overflow-y: auto")
    //-       //-     div.med-button(v-for="combo, ind in comboSets" @click="setCombo(combo, ind)" :class="{ 'selected-med-button': combo.selected }") 
    //-       //-       span {{ combo.code }} - {{ combo.generic_name }}
    //-     div.col-12(v-show="selectMedType === 'group'")
    //-       div.med-group-wrapper(v-if="group.length > 0")
    //-         ul.nav.nav-pills.nav-fill.nav-autoix
    //-           li.nav-item(v-for="g, index in group" @click="currentGroupIndex = index")
    //-             div.nav-link(:class="{ 'active': currentGroupIndex === index }" ) {{g.name}}
    //-         div.med-select(style="height: 360px; overflow-y: auto")
    //-           div.med-button(
    //-             :class="{ 'selected-med-button': med.selected, 'unselectable': med.amountInSystem === 0 }"
    //-             v-for="med, index in group[currentGroupIndex].medicine_set"
    //-             @click="selectMed('group', index)") 
    //-             div#med_desc
    //-               h6 {{ med.code }} - {{ med.CGMH_number }}
    //-               h6 {{ med.generic_name }}
    //-             div#remain_amount 
    //-               span 系統存量
    //-               span {{ med.amountInSystem }}

    //- div.col-6.offset-col-3(v-if="currentProgress === 'inputMedRecordNo'")
    //-   div.with-child-centered
    //-     h4.text-center 請輸入病歷號
    //-     input.form-control(v-model="medRecordId")
      //- div.text-center.mb-2
      //-   button.btn.btn-lg.confirm-button(@click="startAction") 開始取藥
    //- button(@click="nextProgress")


</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import ScanBarcode from './ScanBarcode';

export default {
  name: 'CreateSchedule',
  props: {
    medRecordId: {
      type: String,
      default: '',
    },
    manualInputMedRecordId: {
      type: Boolean,
      default: true,
    },
    bedId: {
      type: Number,
      default: undefined,
    },
    gender: {
      type: String,
      default: null,
    }
  },
  components: {
    ScanBarcode,
  },
  data() {
    return {
      progress: ['selectMed', 'selectBed', 'inputMedRecordNo'],
      currentProgressIndex: 0,
      comboSet: [],
      currentComboSetIndex: 0,
      combos: [],
      combosets: {},
      beds: [],
      group: [],
      selectMedType: 'set',
      selectedSet: undefined,
      currentGroupIndex: 0,
      //medRecordId: '',
      patientSetId: undefined,
      comboSelected: undefined,
      scheduleCreatedId: undefined,
      //bedId: undefined,
    };
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    currentProgress() {
      const currentProgress = this.progress[this.currentProgressIndex];
      return currentProgress;
    },
  },
  created() {
    this.getCombo();
    this.getBed();
    // this.getGroup();
    // this.getComboSet();
    // this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
    this.$emit('emitProgress', 0);
  },
  mounted() {
    this.$refs.medInput.focus();
  },
  watch: {
    medRecordId(val) {
      this.$emit('createReady');
    },
    currentProgressIndex(val) {
      console.log(val);
      this.$emit('emitProgress', val);
    },
  },
  methods: {
    async getBarcode(val) {
      const data = val.toString();
      const returnScheduleId = parseInt(data.split(':')[1].split('***')[0], 10);
      await this.$store.dispatch('setCurrentScheduleById', returnScheduleId);
      this.$emit('createDone');
    },
    previousProgress() {
      if (this.currentProgressIndex > 0) {
        this.currentProgressIndex -= 1;
        this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
      }
    },
    nextProgress() {
      if (this.currentProgressIndex < this.progress.length - 1) {
        if (this.checkForm()) {
          this.currentProgressIndex += 1;
          this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
        }
      }
    },
    getCombo() {
      this.instance.get('/api/medication/', {
        params: {
          type: 'combo',
        },
      })
      .then((res) => {
        const sep = {};
        res.data.results.forEach((item) => {
          item.selected = false;
          const dep = item.generic_name.split('-')[0];
          if (sep[dep] === undefined) {
            sep[dep] = {};
            sep[dep].dep_name = dep;
            sep[dep].combolist = [];
          }
          sep[dep].combolist.push(item);
        });
        Object.values(sep).forEach((set) => {
          set.combolist.sort((a, b) => { return a.generic_name.localeCompare(b.generic_name, 'zh-Hant'); });
        });
        this.combosets = sep;
        this.combos = _.orderBy(Object.values(sep), ['dep_name'], ['asc']);
      });
    },
    getBed() {
      this.instance.get('/api/bed/')
      .then((res) => {
        res.data.forEach((item) => { item.selected = false; });
        this.beds = res.data;
      });
    },
    setCombo(combo, comboInd) {
      console.log(this.selectedSet);
      this.combosets[this.selectedSet].combolist.forEach((combo) => { combo.selected = false; });
      this.combosets[this.selectedSet].combolist[comboInd].selected = true;
      this.comboSelected = combo.id;
    },
    setBed(bed, ind) {
      this.beds.forEach((item) => { item.selected = false; });
      this.beds[ind].selected = true;
      this.bedId = bed.id;
    },
    checkForm() {
      if (this.medRecordId === '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請先輸入病歷號',
        });
        return false;
      }
      // if (this.bedId === undefined && this.currentProgress === 'selectBed') {
      //   this.$store.commit('SET_MESSAGE', {
      //     type: 'error',
      //     context: '請先輸入床號',
      //   });
      //   return false;
      // }
      if (this.comboSelected === undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請先選擇套藥',
        });
        return false;
      }
      return true;
    },
    checkPatientExist() {
      return this.instance.get('/api/patient/', { params: {
        med_record_number: this.medRecordId,
        gender: this.gender,
      } })
      .then((res) => {
        if (res.data.length > 0){ 
          this.patientSetId = res.data[0].id;
          console.log('病人已存在');
        }
        else{
          console.log('病人不存在')
        }
        //console.log(res);
      });
    },
    createPatient() {
      if (this.patientSetId === undefined) {
        return this.instance.post('/api/patient/', {
          med_record_number: this.medRecordId,
        })
        .then((res) => {
          this.patientSetId = res.data.id;
          console.log('新增病人')
        });
      }
      return false;
    },
    checkScheduleExist() {
      const time = new Date();
      return this.instance.get('/api/schedule/', { params: {
        patient: this.patientSetId,
        date: moment().format('YYYY-MM-DD'),
        medication: this.comboSelected,
        bed: this.bedId,
      } })
      .then((res) => {
        if (res.data.length > 0) {
          this.$store.commit('SET_MESSAGE', { context: '此排程已存在，自動帶入該排程', type: 'warn' });
          this.scheduleCreatedId = res.data[0].id;
          console.log('排程已存在');
        }
        else{
          console.log('排程不存在');
        }
      });
    },
    createSchedule() {
      const datetimenow = new Date();
      if (this.scheduleCreatedId === undefined) {
        return this.instance.post('/api/schedule/', {
          patient: this.patientSetId,
          medication: this.comboSelected,
          time: datetimenow.toISOString(),
          bed: this.bedId,
        })
        .then((res) => {
          this.scheduleCreatedId = res.data.id;
          console.log('新增排程');
        });
      }
      return false;
    },
    getSchedule() {
      return this.instance.get(`/api/schedule/${this.scheduleCreatedId}/`)
      .then((res) => {
        this.$store.commit('SET_CURRENT_SCHEDULE_DIRECTLY', res.data);
      });
    },
    getGroup() {
      this.instance.get('/api/medication-group/')
      .then((res) => {
        res.data.forEach((group) => {
          group.medicine_set.forEach((item) => {
            item.selected = false;
            item.drugInDevice = _.filter(this.$store.getters.drugInDeviceList, (drugStorage) => {
              return drugStorage.medication.id === item.id && drugStorage.stock > 0;
            });
            item.amountInSystem = 0;
            item.drugInDevice.forEach((d) => {
              item.amountInSystem += d.stock;
            });
          });
        });
        this.group = res.data;
      });
    },
    getComboSet() {
      this.instance.get('/api/combo-medication-set/')
      .then((res) => {
        const comboMedSets = {};
        res.data.forEach((relation) => {
          if (comboMedSets[relation.parent_medication.id] === undefined) {
            comboMedSets[relation.parent_medication.id] = {};
            comboMedSets[relation.parent_medication.id].id = relation.parent_medication.id;
            comboMedSets[relation.parent_medication.id].name = relation.parent_medication.generic_name;
            comboMedSets[relation.parent_medication.id].childMedSet = [];
            comboMedSets[relation.parent_medication.id].selected = false;
          }
          const childMed = relation.child_medication;
          childMed.selected = false;
          childMed.drugInDevice = _.filter(this.$store.getters.drugInDeviceList, (drugStorage) => {
            return drugStorage.medication.id === childMed.id && drugStorage.stock > 0;
          });
          childMed.amountInSystem = 0;
          childMed.drugInDevice.forEach((d) => {
            childMed.amountInSystem += d.stock;
          });
          comboMedSets[relation.parent_medication.id].childMedSet.push(childMed);
        });
        console.log(comboMedSets);
        this.comboSet = Object.values(comboMedSets);
      });
    },
    selectMed(type, index) {
      let med;
      if (type === 'group') {
        med = this.group[this.currentGroupIndex].medicine_set[index];
      }
      if (type === 'comboSet') {
        med = this.comboSet[this.currentComboSetIndex].childMedSet[index];
        this.comboSelected = this.comboSet[this.currentComboSetIndex].id;
      }
      med.selected = !med.selected;
      const payload = {
        med,
        drugStorage: med.drugInDevice,
        amount: 1,
        select: med.selected,
      };
      this.$store.dispatch('setDrugListForFetch', payload);
    },
    changeSelectMedType() {
      if (this.selectMedType === 'set') {
        this.selectMedType = 'group';
      } else {
        this.selectMedType = 'set';
      }
    },
    async startAction() {
      if (this.checkForm()) {
        await this.checkPatientExist();
        await this.createPatient();
        await this.checkScheduleExist();
        await this.createSchedule();
        await this.getSchedule();
        this.$emit('createDone');
      }
    },
    async gotoFetchDrugGroup() {
      if (this.medRecordId === '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請先輸入病歷號',
        });
        return false;
      }
      else{
        await this.checkPatientExist();
        await this.createPatient();
        await this.checkScheduleExist();
        await this.createSchedule();
        await this.getSchedule();
        this.$router.push({ name: 'fetchDrugGroup' });   
      }   
    }
  },
};
</script>

<style lang="sass">
.button-wrapper
  width: 100%
  justify-content: center
  height: 300px;
  overflow-y: auto;
  border: 1px solid gainsboro;
  padding: 10px;
  &::-webkit-scrollbar-track
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 15px;
    background-color: #F5F5F5;
  &::-webkit-scrollbar
    width: 12px;
    background-color: #F5F5F5;  
  &::-webkit-scrollbar-thumb
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #555;


.control-button-green
  background-color: cadetblue
  color: white
  width: 168px
  height: 80px

.control-button-custom
  display: inline-block;
  border-radius: 3px;
  vertical-align: top

.control-button-selected
  background-color: red !important
</style>



// WEBPACK FOOTER //
// CreateSchedule.vue?1a5c38ed